import { Routes } from '@angular/router';
import { HomeComponent } from './components/home.component';

export const routes: Routes = [
	{ path: '', component: HomeComponent },
	{
		path: 'projects',
		loadComponent: () => import('./scenarios/project-list/project-list').then(m => m.ProjectListComponent)
	},
	{
		path: 'vsub',
		loadComponent: () => import('./scenarios/vsub/vsub.component').then(m => m.VirtualSubscriberComponent)
	},
	{
		path: 'vsub/:projectId',
		loadComponent: () => import('./scenarios/vsub/vsub.component').then(m => m.VirtualSubscriberComponent)
	},
	{
		path: 'admin/map-tiling',
		loadComponent: () =>
			import('./scenarios/map-tiling-admin/map-tiling-admin.component').then(m => m.MapTilingAdminComponent)
	},
];
